import { render, staticRenderFns } from "./BDXStatusPendingManagerListPagination.vue?vue&type=template&id=517dab09&scoped=true"
import script from "./BDXStatusPendingManagerListPagination.vue?vue&type=script&lang=js"
export * from "./BDXStatusPendingManagerListPagination.vue?vue&type=script&lang=js"
import style0 from "./BDXStatusPendingManagerListPagination.vue?vue&type=style&index=0&id=517dab09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517dab09",
  null
  
)

export default component.exports